import {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';

import Button from 'src/componentes/button';
import ContentManager from 'src/componentes/content-manager';
import Dialog from 'src/componentes/dialog';
import FormularioGlobalRespostaPreview, {
  buildFormularioGlobalSections,
} from 'src/componentes/formulario-global/FormularioGlobalRespostaPreview';
import { randomizeFormularioGlobalSections } from 'src/componentes/formulario-global/formularioGlobalQuestionOrder';
import guid from 'src/utils/guid';
import FormularioPesquisaClimaBuilder from '../FormularioPesquisaClimaBuilder';

const FormularioPesquisaClimaPreviewDialog = ({ formulario, ...rest }) => {
  const intl = useIntl();
  const dialogRef = useRef();
  const [answers, setAnswers] = useState({});
  const [randomizationKey] = useState(guid);
  const sections = useMemo(() => {
    const orderedSections = buildFormularioGlobalSections(formulario, intl);

    return formulario?.randomizarPerguntas
      ? randomizeFormularioGlobalSections(orderedSections, randomizationKey)
      : orderedSections;
  }, [formulario, intl, randomizationKey]);

  const handleClose = () => {
    dialogRef.current?.close();
  };

  const handleAnswerChange = (questionKey, patch) => {
    setAnswers((currentAnswers) => ({
      ...currentAnswers,
      [questionKey]: {
        ...(currentAnswers[questionKey] || {}),
        ...patch,
      },
    }));
  };

  return (
    <Dialog
      actions={[
        <Button color="secondary" key="fechar" onClick={handleClose}>
          {intl.formatMessage({ id: 'label.fechar' })}
        </Button>,
      ]}
      ignoreResourceTitle
      maxHeight="90%"
      maxWidth="90%"
      minWidth="80%"
      onRequestClose={handleClose}
      ref={dialogRef}
      title={intl.formatMessage({ id: 'visualizar' })}
      {...rest}
    >
      <FormularioGlobalRespostaPreview
        answers={answers}
        embedded
        formulario={formulario}
        onAnswerChange={handleAnswerChange}
        sections={sections}
        titleFallback={intl.formatMessage({ id: 'labelFormularioSemTitulo' })}
      />
    </Dialog>
  );
};

const FormularioPesquisaClimaTabContent = forwardRef(
  (
    { active, disabled, entidadeId, formularioId, randomizarPerguntas },
    ref
  ) => {
    const builderRef = useRef();

    useImperativeHandle(ref, () => ({
      validateFormularioGlobal: () =>
        builderRef.current?.validateFormularioGlobal(),
      saveFormularioGlobal: (savedEntidadeId) =>
        builderRef.current?.saveFormularioGlobal(savedEntidadeId),
      getPerguntasCount: () => builderRef.current?.getPerguntasCount?.(),
    }));

    const handlePreview = () => {
      ContentManager.addContent(
        <FormularioPesquisaClimaPreviewDialog
          formulario={builderRef.current?.getFormularioGlobal?.()}
        />
      );
    };

    return (
      <Row>
        <Col md={12}>
          <FormularioPesquisaClimaBuilder
            active={active}
            disabled={disabled}
            entidadeId={entidadeId}
            formularioId={formularioId}
            onPreview={handlePreview}
            randomizarPerguntas={randomizarPerguntas}
            ref={builderRef}
          />
        </Col>
      </Row>
    );
  }
);

export default FormularioPesquisaClimaTabContent;
